// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/trailer.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID, Point } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/trailer.proto.
 */
export const file_transportation_v1_trailer: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * Trailer message definition
 *
 * @generated from message transportation.v1.Trailer
 */
export type Trailer = Message<"transportation.v1.Trailer"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.TrailerStatus status = 2;
   */
  status: TrailerStatus;

  /**
   * @generated from field: types.Point current_location = 3;
   */
  currentLocation?: Point;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 4;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: string license_plate = 5;
   */
  licensePlate: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_plate_expiration = 6;
   */
  licensePlateExpiration?: Timestamp;

  /**
   * @generated from field: double capacity = 7;
   */
  capacity: number;

  /**
   * @generated from field: string country = 8;
   */
  country: string;

  /**
   * @generated from field: string state = 9;
   */
  state: string;

  /**
   * @generated from field: string notes = 10;
   */
  notes: string;

  /**
   * @generated from field: string vin = 11;
   */
  vin: string;

  /**
   * @generated from field: types.ID transportation_type_id = 12;
   */
  transportationTypeId?: ID;

  /**
   * @generated from field: types.ID facility_id = 13;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.Base base = 14;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.Trailer.
 * Use `create(TrailerSchema)` to create a new message.
 */
export const TrailerSchema: GenMessage<Trailer> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 0);

/**
 * Request/Response messages for Trailer queries
 *
 * @generated from message transportation.v1.GetTrailerRequest
 */
export type GetTrailerRequest = Message<"transportation.v1.GetTrailerRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetTrailerRequest.
 * Use `create(GetTrailerRequestSchema)` to create a new message.
 */
export const GetTrailerRequestSchema: GenMessage<GetTrailerRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 1);

/**
 * @generated from message transportation.v1.GetTrailerResponse
 */
export type GetTrailerResponse = Message<"transportation.v1.GetTrailerResponse"> & {
  /**
   * @generated from field: transportation.v1.Trailer trailer = 1;
   */
  trailer?: Trailer;
};

/**
 * Describes the message transportation.v1.GetTrailerResponse.
 * Use `create(GetTrailerResponseSchema)` to create a new message.
 */
export const GetTrailerResponseSchema: GenMessage<GetTrailerResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 2);

/**
 * @generated from message transportation.v1.ListTrailersRequest
 */
export type ListTrailersRequest = Message<"transportation.v1.ListTrailersRequest"> & {
  /**
   * @generated from field: transportation.v1.ListTrailersFilter filter = 1;
   */
  filter?: ListTrailersFilter;

  /**
   * @generated from field: repeated transportation.v1.TrailerSortOption sorting = 2;
   */
  sorting: TrailerSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListTrailersRequest.
 * Use `create(ListTrailersRequestSchema)` to create a new message.
 */
export const ListTrailersRequestSchema: GenMessage<ListTrailersRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 3);

/**
 * @generated from message transportation.v1.ListTrailersFilter
 */
export type ListTrailersFilter = Message<"transportation.v1.ListTrailersFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: transportation.v1.TrailerStatus status = 2;
   */
  status: TrailerStatus;

  /**
   * @generated from field: google.protobuf.StringValue license_plate = 3;
   */
  licensePlate?: string;

  /**
   * @generated from field: google.protobuf.StringValue vin = 4;
   */
  vin?: string;

  /**
   * @generated from field: google.protobuf.StringValue transportation_type_id = 5;
   */
  transportationTypeId?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 6;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 7;
   */
  organizationId?: ID;

  /**
   * @generated from field: double min_capacity = 8;
   */
  minCapacity: number;

  /**
   * @generated from field: double max_capacity = 9;
   */
  maxCapacity: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 10;
   */
  lastUpdatedAt?: Timestamp;
};

/**
 * Describes the message transportation.v1.ListTrailersFilter.
 * Use `create(ListTrailersFilterSchema)` to create a new message.
 */
export const ListTrailersFilterSchema: GenMessage<ListTrailersFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 4);

/**
 * @generated from message transportation.v1.ListTrailersResponse
 */
export type ListTrailersResponse = Message<"transportation.v1.ListTrailersResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.Trailer trailers = 1;
   */
  trailers: Trailer[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListTrailersResponse.
 * Use `create(ListTrailersResponseSchema)` to create a new message.
 */
export const ListTrailersResponseSchema: GenMessage<ListTrailersResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 5);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateTrailerRequest
 */
export type CreateTrailerRequest = Message<"transportation.v1.CreateTrailerRequest"> & {
  /**
   * @generated from field: transportation.v1.TrailerInput input = 1;
   */
  input?: TrailerInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateTrailerRequest.
 * Use `create(CreateTrailerRequestSchema)` to create a new message.
 */
export const CreateTrailerRequestSchema: GenMessage<CreateTrailerRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 6);

/**
 * @generated from message transportation.v1.CreateTrailerResponse
 */
export type CreateTrailerResponse = Message<"transportation.v1.CreateTrailerResponse"> & {
  /**
   * @generated from field: transportation.v1.Trailer trailer = 1;
   */
  trailer?: Trailer;
};

/**
 * Describes the message transportation.v1.CreateTrailerResponse.
 * Use `create(CreateTrailerResponseSchema)` to create a new message.
 */
export const CreateTrailerResponseSchema: GenMessage<CreateTrailerResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 7);

/**
 * @generated from message transportation.v1.UpdateTrailerRequest
 */
export type UpdateTrailerRequest = Message<"transportation.v1.UpdateTrailerRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.TrailerUpdateInput input = 2;
   */
  input?: TrailerUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateTrailerRequest.
 * Use `create(UpdateTrailerRequestSchema)` to create a new message.
 */
export const UpdateTrailerRequestSchema: GenMessage<UpdateTrailerRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 8);

/**
 * @generated from message transportation.v1.UpdateTrailerResponse
 */
export type UpdateTrailerResponse = Message<"transportation.v1.UpdateTrailerResponse"> & {
  /**
   * @generated from field: transportation.v1.Trailer trailer = 1;
   */
  trailer?: Trailer;
};

/**
 * Describes the message transportation.v1.UpdateTrailerResponse.
 * Use `create(UpdateTrailerResponseSchema)` to create a new message.
 */
export const UpdateTrailerResponseSchema: GenMessage<UpdateTrailerResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 9);

/**
 * @generated from message transportation.v1.DeleteTrailerRequest
 */
export type DeleteTrailerRequest = Message<"transportation.v1.DeleteTrailerRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.DeleteTrailerRequest.
 * Use `create(DeleteTrailerRequestSchema)` to create a new message.
 */
export const DeleteTrailerRequestSchema: GenMessage<DeleteTrailerRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 10);

/**
 * Input messages
 *
 * @generated from message transportation.v1.TrailerInput
 */
export type TrailerInput = Message<"transportation.v1.TrailerInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.TrailerStatus status = 2;
   */
  status: TrailerStatus;

  /**
   * @generated from field: types.Point current_location = 3;
   */
  currentLocation?: Point;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 4;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: string license_plate = 5;
   */
  licensePlate: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_plate_expiration = 6;
   */
  licensePlateExpiration?: Timestamp;

  /**
   * @generated from field: double capacity = 7;
   */
  capacity: number;

  /**
   * @generated from field: string country = 8;
   */
  country: string;

  /**
   * @generated from field: string state = 9;
   */
  state: string;

  /**
   * @generated from field: string notes = 10;
   */
  notes: string;

  /**
   * @generated from field: string vin = 11;
   */
  vin: string;

  /**
   * @generated from field: types.ID transportation_type_id = 12;
   */
  transportationTypeId?: ID;

  /**
   * @generated from field: types.ID facility_id = 13;
   */
  facilityId?: ID;
};

/**
 * Describes the message transportation.v1.TrailerInput.
 * Use `create(TrailerInputSchema)` to create a new message.
 */
export const TrailerInputSchema: GenMessage<TrailerInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 11);

/**
 * @generated from message transportation.v1.TrailerUpdateInput
 */
export type TrailerUpdateInput = Message<"transportation.v1.TrailerUpdateInput"> & {
  /**
   * @generated from field: transportation.v1.TrailerStatus status = 1;
   */
  status: TrailerStatus;

  /**
   * @generated from field: google.protobuf.StringValue current_location = 2;
   */
  currentLocation?: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 3;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue license_plate = 4;
   */
  licensePlate?: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_plate_expiration = 5;
   */
  licensePlateExpiration?: Timestamp;

  /**
   * @generated from field: google.protobuf.DoubleValue capacity = 6;
   */
  capacity?: number;

  /**
   * @generated from field: google.protobuf.StringValue country = 7;
   */
  country?: string;

  /**
   * @generated from field: google.protobuf.StringValue state = 8;
   */
  state?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue vin = 10;
   */
  vin?: string;

  /**
   * @generated from field: types.ID transportation_type_id = 11;
   */
  transportationTypeId?: ID;

  /**
   * @generated from field: types.ID facility_id = 12;
   */
  facilityId?: ID;
};

/**
 * Describes the message transportation.v1.TrailerUpdateInput.
 * Use `create(TrailerUpdateInputSchema)` to create a new message.
 */
export const TrailerUpdateInputSchema: GenMessage<TrailerUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer, 12);

/**
 * TrailerStatus enum
 *
 * @generated from enum transportation.v1.TrailerStatus
 */
export enum TrailerStatus {
  /**
   * @generated from enum value: TRAILER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAILER_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: TRAILER_STATUS_IN_USE = 2;
   */
  IN_USE = 2,

  /**
   * @generated from enum value: TRAILER_STATUS_INACTIVE = 3;
   */
  INACTIVE = 3,

  /**
   * @generated from enum value: TRAILER_STATUS_OUT_OF_SERVICE = 4;
   */
  OUT_OF_SERVICE = 4,
}

/**
 * Describes the enum transportation.v1.TrailerStatus.
 */
export const TrailerStatusSchema: GenEnum<TrailerStatus> = /*@__PURE__*/
  enumDesc(file_transportation_v1_trailer, 0);

/**
 * @generated from enum transportation.v1.TrailerSortOption
 */
export enum TrailerSortOption {
  /**
   * @generated from enum value: TRAILER_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_STATUS_ASC = 1;
   */
  STATUS_ASC = 1,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_STATUS_DESC = 2;
   */
  STATUS_DESC = 2,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_LAST_LOCATION_TIME_ASC = 3;
   */
  LAST_LOCATION_TIME_ASC = 3,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_LAST_LOCATION_TIME_DESC = 4;
   */
  LAST_LOCATION_TIME_DESC = 4,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_LICENSE_PLATE_ASC = 5;
   */
  LICENSE_PLATE_ASC = 5,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_LICENSE_PLATE_DESC = 6;
   */
  LICENSE_PLATE_DESC = 6,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_CAPACITY_ASC = 7;
   */
  CAPACITY_ASC = 7,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_CAPACITY_DESC = 8;
   */
  CAPACITY_DESC = 8,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_CREATED_AT_ASC = 9;
   */
  CREATED_AT_ASC = 9,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_CREATED_AT_DESC = 10;
   */
  CREATED_AT_DESC = 10,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_UPDATED_AT_ASC = 11;
   */
  UPDATED_AT_ASC = 11,

  /**
   * @generated from enum value: TRAILER_SORT_OPTION_UPDATED_AT_DESC = 12;
   */
  UPDATED_AT_DESC = 12,
}

/**
 * Describes the enum transportation.v1.TrailerSortOption.
 */
export const TrailerSortOptionSchema: GenEnum<TrailerSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_trailer, 1);

/**
 * Services
 *
 * @generated from service transportation.v1.TrailerQueriesService
 */
export const TrailerQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.TrailerQueriesService.GetTrailer
   */
  getTrailer: {
    methodKind: "unary";
    input: typeof GetTrailerRequestSchema;
    output: typeof GetTrailerResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.TrailerQueriesService.ListTrailers
   */
  listTrailers: {
    methodKind: "unary";
    input: typeof ListTrailersRequestSchema;
    output: typeof ListTrailersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_trailer, 0);

/**
 * @generated from service transportation.v1.TrailerCommandsService
 */
export const TrailerCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.TrailerCommandsService.CreateTrailer
   */
  createTrailer: {
    methodKind: "unary";
    input: typeof CreateTrailerRequestSchema;
    output: typeof CreateTrailerResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.TrailerCommandsService.UpdateTrailer
   */
  updateTrailer: {
    methodKind: "unary";
    input: typeof UpdateTrailerRequestSchema;
    output: typeof UpdateTrailerResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.TrailerCommandsService.DeleteTrailer
   */
  deleteTrailer: {
    methodKind: "unary";
    input: typeof DeleteTrailerRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_trailer, 1);

